module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infinite-loading-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_vm._t("spinner", function() {
    return [_c('i', {
      class: _vm.spinnerType
    })]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && _vm.isComplete && _vm.isFirstLoad),
      expression: "!isLoading && isComplete && isFirstLoad"
    }],
    staticClass: "infinite-status-prompt"
  }, [_vm._t("no-results", function() {
    return [_vm._v("网络错误请稍后重试")]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && _vm.isComplete && !_vm.isFirstLoad),
      expression: "!isLoading && isComplete && !isFirstLoad"
    }],
    staticClass: "infinite-status-prompt"
  }, [_vm._t("no-more")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c15eeee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfiniteLoading.vue
// module id = 216
// module chunks = 3